export function analyzeText(text, analysisPrompt) {
  if (!text || !text.trim()) return null;

  const toneIndicators = {
    formal: /\b(furthermore|therefore|consequently|accordingly|nevertheless)\b/gi,
    casual: /\b(hey|cool|awesome|totally|yeah|btw)\b/gi,
    urgent: /\b(asap|urgent|immediately|critical|must|need to)\b/gi,
    friendly: /\b(thanks|please|appreciate|wonderful|great|amazing)\b/gi,
    confident: /\b(will|definitely|certainly|absolutely|ensure|guarantee)\b/gi,
    tentative: /\b(maybe|perhaps|possibly|might|could|should probably)\b/gi
  };

  const tones = Object.entries(toneIndicators).map(([tone, regex]) => {
    const m = text.match(regex);
    return m?.length ? { tone, count: m.length } : null;
  }).filter(Boolean).sort((a, b) => b.count - a.count);

  const sentences = text.split(/[.!?]+/).filter(s => s.trim().length > 10);
  const keyMessages = sentences.slice(0, 2).map(s => s.trim());
  const wordCount = text.split(/\s+/).filter(Boolean).length;
  const characterCount = text.length;

  return {
    tones,
    keyMessages,
    wordCount,
    characterCount,
    timestamp: new Date().toLocaleString(),
    prompt: analysisPrompt
  };
}
